const isAutomationsRoutePath = (value) => {
  const normalizedValue = String(value || '').trim();
  return normalizedValue === '/automations' || normalizedValue.startsWith('/automations/');
};

const normalizeAutomationRouteType = (value) => {
  const normalizedValue = String(value || '')
    .trim()
    .toLowerCase();

  if (normalizedValue === 'schedule' || normalizedValue === 'schedules') {
    return 'schedules';
  }

  if (normalizedValue === 'trigger' || normalizedValue === 'triggers') {
    return 'triggers';
  }

  if (normalizedValue === 'workflow' || normalizedValue === 'workflows') {
    return 'workflows';
  }

  return '';
};

const buildAutomationsViewPath = ({ type, id } = {}) => {
  const normalizedType = normalizeAutomationRouteType(type);
  const normalizedId = String(id || '').trim();

  if (!normalizedType || !normalizedId) {
    return '/automations';
  }

  return `/automations/${normalizedType}/${normalizedId}`;
};

// A workflow thread opened from Automate stays in Automate: this route renders the whole workflow
// surface — plan or step editor, controls rail, chat beside it — inside the Automate shell. The id is
// the thread id, so the route needs nothing hydrated before it can render.
const buildAutomationsWorkflowThreadPath = (threadId) => {
  const normalizedThreadId = String(threadId || '').trim();

  if (!normalizedThreadId) {
    return '/automations';
  }

  return `/automations/workflows/${normalizedThreadId}/conversation`;
};

const getAutomationsRouteContext = (value) => {
  const normalizedValue = String(value || '').trim();

  if (!normalizedValue.startsWith('/automations')) {
    return {
      type: '',
      id: '',
      isConversation: false,
      isEdit: false
    };
  }

  const segments = normalizedValue.split('/').filter(Boolean);
  const routeType = normalizeAutomationRouteType(segments[1]);
  const routeId = String(segments[2] || '').trim();
  const isConversation = routeType === 'workflows' && segments[3] === 'conversation';
  const isEdit = segments[3] === 'edit';

  return {
    type: routeType,
    id: routeId,
    isConversation,
    isEdit
  };
};

const AUTOMATION_THREAD_BREADCRUMB_META = Object.freeze({
  workflows: { label: 'Workflows', fallbackTitle: 'Workflow', listPath: '/automations?filter=workflows' },
  schedules: { label: 'Schedules', fallbackTitle: 'New schedule', listPath: '/automations?filter=schedules' },
  triggers: { label: 'Triggers', fallbackTitle: 'New trigger', listPath: '/automations?filter=triggers' }
});

export { AUTOMATION_THREAD_BREADCRUMB_META, buildAutomationsViewPath, buildAutomationsWorkflowThreadPath, getAutomationsRouteContext, isAutomationsRoutePath, normalizeAutomationRouteType };
